import {
	SPLIT_DOC_PARAMETERS,
	GLOBAL_COUNTRY,
	PLATFORMS,
	FRAMERATE_CONSTANTS,
	SCRIPT_TYPES
} from '../core/constants';

const {
	SITE_ID,
	SITE_DOMAIN,
	SCRIPTS,
	SPLIT_CONFIGS,
	ENABLED,
	TYPE,
	VALUE,
	DEFER,
	ASYNC,
	ARCHIVED,
	SPLITS,
	KEY,
	SPLIT
} = SPLIT_DOC_PARAMETERS;
const FRAMERATE = 'FRAMERATE';
const { GLOBAL_PLATFORM } = PLATFORMS;
const { HTML } = SCRIPT_TYPES;

export const isSplitDocValid = (splitDoc) => {
	if (!splitDoc[SITE_ID]) {
		throw new Error('Site Id invalid');
	}
	if (typeof splitDoc[SITE_ID] !== 'number') {
		throw new Error('Site Id is not a number');
	}
	if (typeof splitDoc[SITE_DOMAIN] !== 'string' || !splitDoc[SITE_DOMAIN]) {
		throw new Error('Site Domain invalid!');
	}
	if (typeof splitDoc[SCRIPTS] !== 'object') {
		throw new Error('Scripts invalid');
	}
	if (typeof splitDoc[SPLIT_CONFIGS] !== 'object') {
		throw new Error('Split Configs invalid!');
	}
	if (typeof splitDoc[ENABLED] !== 'boolean') {
		throw new Error('Enabled is not boolean!');
	}

	checkScripts(splitDoc[SCRIPTS], splitDoc[SITE_ID]);
	const scriptNames = Object.keys(splitDoc[SCRIPTS]);
	checkSplits(splitDoc[SPLIT_CONFIGS], scriptNames);
};

const checkScripts = (scriptsObj, siteId) => {
	//FRAMERATE must always be present as script
	if (!scriptsObj[FRAMERATE]) {
		throw new Error('Framerate script is missing in scripts!');
	}
	//Framerate script url must be correct
	const frameRateScriptUrl = `${FRAMERATE_CONSTANTS.DOMAIN}/${siteId}/${FRAMERATE_CONSTANTS.BUNDLE_NAME}`;
	if (scriptsObj[FRAMERATE][VALUE] !== frameRateScriptUrl) {
		throw new Error('Framerate script url invalid!');
	}

	Object.keys(scriptsObj).forEach((scriptName) => {
		const scriptObj = scriptsObj[scriptName];
		if (typeof scriptObj[TYPE] !== 'string' || !scriptObj[TYPE]) {
			throw new Error(`Type is not valid in script :${scriptName}`);
		}
		if (typeof scriptObj[VALUE] !== 'string' || !scriptObj[VALUE]) {
			throw new Error(`Value is not valid in script :${scriptName}`);
		}

		if (typeof scriptObj[DEFER] !== 'boolean') {
			throw new Error(`Defer value must be a boolean in script :${scriptName}`);
		}
		if (typeof scriptObj[ASYNC] !== 'boolean') {
			throw new Error(`Async value must be a boolean in script :${scriptName}`);
		}
		if (scriptObj[ASYNC] && scriptObj[DEFER]) {
			throw new Error(`Both async and defer cannot be true for script : ${scriptName}`);
		}
		if (scriptObj[TYPE] === HTML && scriptObj[DEFER]) {
			throw new Error(`Defer cannot be true for Html type script : ${scriptName}`);
		}
		if (scriptObj[TYPE] === HTML && scriptObj[ASYNC]) {
			throw new Error(`Async cannot be true for Html type script : ${scriptName}`);
		}
	});
};

const checkSplits = (splitConfigs, scriptNames) => {
	if (!splitConfigs[GLOBAL_PLATFORM]) {
		throw new Error('Global Platform must be present!');
	}
	const platforms = Object.keys(splitConfigs);
	platforms.forEach((platformName) => {
		const platformConfig = splitConfigs[platformName];
		if (!platformConfig[GLOBAL_COUNTRY]) {
			throw new Error('Global Country must be present!');
		}
		const countries = Object.keys(platformConfig);

		countries.forEach((countryName) => {
			const countryConfig = platformConfig[countryName];
			if (typeof countryConfig[ARCHIVED] !== 'boolean') {
				throw new Error(`Archived must be boolean !`);
			}
			checkSplitArr(countryConfig[SPLITS], scriptNames);
		});
	});
};

const checkSplitArr = (splitArr, scriptNames) => {
	if (!Array.isArray(splitArr)) {
		throw new Error('splits must be an array!');
	}
	let splitSum = 0;
	let frameRateSplitPresent = false;

	splitArr.forEach((splitObj) => {
		if (typeof splitObj[KEY] !== 'string' || !splitObj[KEY]) {
			throw new Error('split key must be a string and not empty!');
		}
		if (!scriptNames.includes(splitObj[KEY])) {
			throw new Error(`${splitObj[KEY]} script is missing in scripts`);
		}
		if (splitObj[KEY] === FRAMERATE) {
			frameRateSplitPresent = true;
		}
		if (typeof splitObj[SPLIT] !== 'number') {
			throw new Error('split value must be a number');
		}
		if (splitObj[SPLIT] < 0 || splitObj[SPLIT] > 100) {
			throw new Error('split value must be >=0 and <=100');
		}
		splitSum += splitObj[SPLIT];
	});

	if (!frameRateSplitPresent) {
		throw new Error('FrameRate split is not present!');
	}
	if (splitSum !== 100) {
		throw new Error('Split Invalid');
	}
};
